import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import HomeScreen from './screens/HomeScreen';
import data from './data';
import Header from './components/Header';

const App = () => {
 return (
  <Router>
   <Header header={data.header} />
   <div className='py-3  backgroundBody'>
    <Container>
     <Routes>
      <Route path='/' element={<HomeScreen data={data} />} />
     </Routes>
    </Container>
   </div>
  </Router>
 );
};

export default App;
